import { BUTTON_TYPES, FORM_KEYS } from './form-manager.constants';

export const BUTTONS_CAUSE_VALIDATION = [
  'sign-off',
  'bulk-upload',
  'submit-control-print',
  'batch-submit',
];

export const LOOKUP_TYPES = {
  AUTOCOMPLETE: 'AUTOCOMPLETE',
};

export const ONE_TO_MANY = [
  '1toMany',
  'System',
  '1TOMANYDEFERCONTENTROCESSING',
  '1TOMANY',
  'NONPERSISTENT',
  '1TOMANYDYNAMICENTITY',
];

export const LINK_TARGETS = {
  NEW_WINDOW: '_blank',
  POPUP_WINDOW: '_popup',
  CURRENT_WINDOW: '_top',
  WORKSPACE: '_self',
};

export const ICON_CLICK_ACTIONS = {
  PREVIEW: 'Preview',
  DOWNLOAD: 'Download',
};

export const OFFLINE_TAB_PART_ID = 'part1-tab1';
export const OFFLINE_ENTITY_TYPE = 'SS_AUDIT';

export const CRITICAL_STORAGE_CAPACITY = 1024 * 1024 * 2000; // - in bytes

export const DOWNLOAD_ICON_ACTIONS_TYPES = {
  DOWNLOAD: 'Download',
  DOWNLOADED: 'Downloaded',
  DOWNLOADING: 'Downloading',
  DELETE: 'Delete',
};

export const EXTERNAL_DATASOURCE_TYPES = ['SMARTSOLVEDATA', 'EXTERNALDATA', 'LISTDATA'];

export const FILE_SOURCES = {
  DOCUMENT_COMPARE: 'document-compare',
};

export const UPDATE_RULES_SUPPORTED_TYPES = ['SET_DEFAULT', 'UPDATE_FIELD'];
export const INTERACTION_RULES_SUPPORTED_TYPES = ['ADD_ROW', 'CLEAR_TABLE', 'REBIND_CANVAS'];

export const DECISION_TREE_QUERY_PARAM_NAMES = [
  'containerWorkflowKey',
  'currentWorkFlowId',
  'decisionTreeName',
  'itmId',
  'fnpCode',
  'isApprovedforASR',
  'regulatoryBody',
  'regulatoryCenter',
  'stepId',
  'workflowKey',
];

export const RUNTIME_FORMS = [FORM_KEYS.STEP, FORM_KEYS.MODAL];

export const ACTIONS_TRIGGER_VALIDATION = [
  'LOAD_DATA',
  'UPLOAD_ATTACHMENTS_SUCCESS',
  'ADD_NEW_ROW',
  'BULK_ADDING_NEW_ROWS',
  'BULK_UPDATE_FORM_DATA',
  'CLEAR_TABLE',
  'DELETE_FORM_DATA_ROW',
  'UPDATE_DATA_SUCCESS',
  'SET_ACTIVE_CONTAINERS',
  'UPDATE_ENTITY_ROWS',
];

export const BUTTON_TYPES_SUPPORT_DISABLE = [
  BUTTON_TYPES.SAVE_AND_SIGNOFF,
  BUTTON_TYPES.SAVE_WITHOUT_SIGNOFF,
  BUTTON_TYPES.OTHER,
];

export const AUTOCOMPLETE_SEARCH_DELAY = 600;

export const AUTOCOMPLETE_NO_OPTIONS_TEXT = {
  TYPE_TO_SEARCH: 'Type to start searching',
  NO_OPTIONS: 'No options found',
};

export const ERROR_CONTAINER_FLEX_BASIS = 370;

export const SELECTED_SUB_GRID_DEFAULT_WIDTH = 600;

export const ENTITY_DISPLAY_LEFT_RIGHT_PADDING = 5;

export const COPY_ROW_SKIP_ATTRIBUTES = [
  'GT_ID',
  'IsExistingObject',
  'IsNewObject',
  'PK_ID',
  'PARENT_GT_ID',
  'ORG_ID',
  'CREATED_DATE',
  'CREATED_BY',
  'MODIFIED_BY',
  'MODIFIED_DATE',
];

export const ACTION_TYPE_SET_DEFAULT = 'SET_DEFAULT';
export const ACTION_TYPE_SET_ERROR = 'SET_ERROR';

export const BAH_CHILD_RECORD_ID = 'BAH_CHILD_RECORD_ID';
export const BAH_CHILD_DATAMEMBER = 'BAH_CHILD_DATAMEMBER';

export const WFE_OFFLINE_RIGHT = 'WFE_OFFLINE';

export const BUILD_NUMBER_COLUMN = 'DCH_DOC_BUILD_NO';

export const FCM_BORDER_STYLES = {
  GREEN: '1px dashed green',
  BLUE: '1px dashed blue',
  CONDITIONAL: ({ isControlAddedFCM }) => `1px dashed ${isControlAddedFCM ? 'green' : 'blue'}`,
};

export const FCM_HIDDEN_CONTROL_STYLES = {
  opacity: 0.5,
  pointerEvents: 'none',
  '& [data-hidden-fcm*="true"]': {
    opacity: '1 !important',
  },
};

export const FCM_BUTTON_STYLES = {
  changesModeWrapper: {
    marginRight: 8,
    padding: '4px 0 4px 16px',
    border: FCM_BORDER_STYLES.CONDITIONAL,
  },
  changesIcon: {
    position: 'relative',
    right: 8,
  },
};

export const FCM_CONTAINER_STYLES = {
  changesModeWrapper: {
    display: 'flex',
    marginBottom: 16,
    padding: ({ isControlAddedFCM }) => `8px ${isControlAddedFCM ? 8 : 0}px 8px 8px`,
    border: FCM_BORDER_STYLES.CONDITIONAL,
  },
  control: {
    flexGrow: 1,
  },
  hiddenControl: FCM_HIDDEN_CONTROL_STYLES,
  changesIcon: {
    padding: '0 8px',
  },
};

export const FORM_CHANGES_TABLE_TYPES = {
  MODIFIED: 'modified',
  ADDED: 'added',
  DELETED: 'deleted',
  MOVED: 'moved',
};

export const FORM_CHANGES_TABLE_DEFAULT_ROWS = {
  [FORM_CHANGES_TABLE_TYPES.MODIFIED]: [],
  [FORM_CHANGES_TABLE_TYPES.ADDED]: [],
  [FORM_CHANGES_TABLE_TYPES.DELETED]: [],
  [FORM_CHANGES_TABLE_TYPES.MOVED]: [],
};

export const DATA_CORRECTIONS_FORM_KEY = 'DATA_CORRECTION';

export const AI_SUMMARY_APP_SETTING_KEY = 'SummarizationService/Enabled';
export const RECORD_SIMILARITY_APP_SETTING_KEY = 'RecordsSimilarity/Enabled';
export const DEFAULT_OPERATION_MESSAGE =
  '80% matching similar record(s) found. Additional information can be viewed in the record Detail. Click here to open the record Detail.';

export const ROLE_MANAGEMENT_ACTIONS_TYPES = {
  ASSIGN: 'Assign',
  DELETE: 'Delete',
};
